import * as yup from "yup";


export const validationSchema = yup.object({
    arabicName: yup
      .string()
      .matches(/^[\u0621-\u064A ]+$/, "Accept Arabic letters only")
      .required("Please fill this required field"),
    englishName: yup
      .string()
      .matches(/^[A-Za-z ]+$/, "Accept English letters only")
      .required("Please fill this required field"),
    code: yup
      .string()
      .matches(/^[A-Z ]+$/, "Accept English Capital letters Only")
      .required("Please fill this required field"),
  });
